import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import dayjs from 'dayjs';
import * as _ from 'lodash';
import { I18n } from 'react-redux-i18n-lite';
import { isBefore } from '../../../utils/dateUtlis';
import * as taskService from '../../../services/domain/taskService';
import {
  getObjectTask,
  getStudentTaskAttempt,
  isGrayState,
  isGreenState,
  isPurpleState,
  isRedState
} from '../../../utils/gradeUtils';
import UserImage from '../../common/UserImage';

class StudentBox extends Component {
  static propTypes = {
    task: PropTypes.object,
    taskStudents: PropTypes.any,
    evaluatedStudent: PropTypes.object,
    avatarsImages: PropTypes.object,
    isExpiredResponse: PropTypes.bool
  };

  renderAvatar = () => {
    const { evaluatedStudent } = this.props;
    const enabledClass = evaluatedStudent.enabled === 1 ? '' : 'opacity-20';
    return (
      <div className={`student-avatar-container ${this.getGradeColor()} ${enabledClass}`}>
        <img src={evaluatedStudent.picture} alt={evaluatedStudent.name} />
      </div>
    );
  };

  getDeliveredFileInfo = () => {
    const { task, evaluatedStudent } = this.props;

    let dateDelivered;
    let fileUrl;
    const studentAttempt = task && task.studentAttempts && task.studentAttempts[evaluatedStudent._id];

    if (!_.isEmpty(studentAttempt) && !_.isEmpty(studentAttempt.responses)) {
      let studentResponse = studentAttempt.responses[0];
      if (!_.isEmpty(studentResponse)) {
        dateDelivered = studentResponse.date;
        if (!_.isEmpty(studentResponse.data)) {
          fileUrl = studentResponse.data.fileUrl;
        }
      }
    }

    const wasFileUploaded = !_.isEmpty(fileUrl);

    return { dateDelivered, fileUrl, studentAttempt, wasFileUploaded };
  };

  getTotalActivitiesResults = () => {
    const { task } = this.props;

    const activities = {
      total: 0,
      passed: 0
    };

    if (task && task.activityStructure) {
      task.activityStructure.map(unit =>
        unit.children.map(lesson =>
          lesson.children.map(activity => {
            activities.total += 1;
            return activity.success ? (activities.passed += 1) : undefined;
          })
        )
      );
    }
    return activities;
  };

  getGradeColor = () => {
    const { evaluatedStudent, task } = this.props;
    if (!task) {
      return '';
    }

    const studentId = evaluatedStudent._id;
    const studentAttempt = getStudentTaskAttempt(task, studentId);
    const objectProjectTask = studentAttempt ? getObjectTask(task, studentId) : null;
    const gradePercentContentAware = taskService.getTaskGrade(task, studentId);

    if (isGrayState(task, objectProjectTask, studentId)) {
      return '';
    }

    if (isPurpleState(task, objectProjectTask, gradePercentContentAware, studentId)) {
      return 'purple';
    }

    if (typeof gradePercentContentAware === 'number') {
      if (isGreenState(task, gradePercentContentAware, objectProjectTask)) {
        return 'green';
      }
      if (isRedState(task, gradePercentContentAware, objectProjectTask)) {
        return 'red';
      }
    }

    return '';
  };

  getStudentGroup = (groupedStudents, studentId) => {
    for (let group in groupedStudents) {
      if (groupedStudents[group].some(student => student._id === studentId)) {
        return group;
      }
    }
    return null;
  };

  renderSpecificGroup = (groupData, users, groupId) => {
    // Filter groupData to get the list of user IDs that belong to the specified groupId
    const userIdsInGroup = Object.values(groupData)
      .filter(user => user.taskGroup === groupId)
      .map(user => user.userId);

    // Filter the users array to get the user details for the filtered user IDs
    const usersInGroup = users.filter(user => userIdsInGroup.includes(user._id));

    if (usersInGroup && usersInGroup.length > 0) {
      return (
        <div className="assignments-panel">
          <div className="users-categories no-padding">
            <div className="users-category">
              <div className="group-title">
                {I18n.t('rightPanel.groups.group')} {groupId}
              </div>
              <div className="users-category-icons">
                {usersInGroup.map(student => (
                  <div key={student._id} className={`user-icon pointer`}>
                    <UserImage picture={student.picture} />
                    <div className="user-name">
                      {student.name} {student.surname}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  getWhoRespondTaskGroupInfo = (task, studentTaskGroupId) => {
    if (!task.whoRespondTaskGroup) {
      return null;
    }
    const groupId = studentTaskGroupId;
    const userId = task.whoRespondTaskGroup[groupId];
    if (userId) {
      return task.users.find(u => u._id === userId);
    }
    return null;
  };

  hasStudentAnswered = (task, evaluatedStudent) => {
    return Boolean(task && task.studentAttempts && task.studentAttempts[evaluatedStudent._id].responses[0]);
  };

  render() {
    const { task, evaluatedStudent, taskStudents } = this.props;
    const { dateDelivered } = this.getDeliveredFileInfo();
    let activities = this.getTotalActivitiesResults();
    const groupedStudents =
      task && taskService.setStudentsInGroups(taskStudents, task, task.resultSummary, 'StudentBox');
    const studentTaskGroup = this.getStudentGroup(groupedStudents, evaluatedStudent._id);
    
    // es dinámico solo si es "groupN"
    const isDynamicGroup = typeof studentTaskGroup === 'string' && /^group\d+$/.test(studentTaskGroup);
    
    // id numérico solo para dinámicos
    const studentTaskGroupId = isDynamicGroup ? studentTaskGroup.replace('group', '') : null;
    
    // whoRespond solo tiene sentido para dinámicos
    const whoRespondTaskGroupInfo = isDynamicGroup
      ? this.getWhoRespondTaskGroupInfo(task, studentTaskGroupId)
      : null;
    
    // “en grupo” si es dinámico o hay respondedor de grupo
    const isInTaskGroup = (isDynamicGroup && studentTaskGroupId && groupedStudents) || whoRespondTaskGroupInfo;
    return (
      <div className="student-delivered-task-container">
        {!isInTaskGroup && this.renderAvatar()}
        <div className="student-name-and-delivered-date">
        {isDynamicGroup ? (
            this.renderSpecificGroup(task.studentAttempts, taskStudents, studentTaskGroupId)
          ) : (
            <div className="student-name">
              {evaluatedStudent.name} {evaluatedStudent.surname}
            </div>
          )}
          {this.hasStudentAnswered(task, evaluatedStudent) ? (
            <div className="delivered-task">
              <span>
                {I18n.t('tasks.delivered')}
                {whoRespondTaskGroupInfo &&
                  ` \u00B7 ${whoRespondTaskGroupInfo.name} ${whoRespondTaskGroupInfo.surname} `}
                <span> &middot; </span>
                {dayjs(dateDelivered).format('DD/MM/YYYY HH:mm')}
              </span>
              <span> &middot; </span>
              {isBefore(task.dueDate, dateDelivered, 'seconds') ? (
                <span className="late">{I18n.t('tasks.late')}</span>
              ) : (
                <span className="on-time">{I18n.t('tasks.onTime')}</span>
              )}
            </div>
          ) : (
            ''
          )}
        </div>
        <div className={`student-passed-tasks ${this.getGradeColor()}`}>
          {activities.total ? `${activities.passed}/${activities.total}` : null}
        </div>
      </div>
    );
  }
}

export default StudentBox;
